var Shopify=Shopify||{};Shopify.money_format="${{amount}}";Shopify.formatMoney=function(cents,format){if(typeof cents=='string'){cents=cents.replace('.','')}
var value='';var placeholderRegex=/\{\{\s*(\w+)\s*\}\}/;var formatString=(format||this.money_format);function defaultOption(opt,def){return(typeof opt=='undefined'?def:opt)}
function formatWithDelimiters(number,precision,thousands,decimal){precision=defaultOption(precision,2);thousands=defaultOption(thousands,',');decimal=defaultOption(decimal,'.');if(isNaN(number)||number==null){return 0}
number=(number/100.0).toFixed(precision);var parts=number.split('.'),dollars=parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,'$1'+thousands),cents=parts[1]?(decimal+parts[1]):'';return dollars+cents}
switch(formatString.match(placeholderRegex)[1]){case 'amount':value=formatWithDelimiters(cents,2);break;case 'amount_no_decimals':value=formatWithDelimiters(cents,0);break;case 'amount_with_comma_separator':value=formatWithDelimiters(cents,2,'.',',');break;case 'amount_no_decimals_with_comma_separator':value=formatWithDelimiters(cents,0,'.',',');break}
return formatString.replace(placeholderRegex,value)};

/**
 * easytimer.js
 * Generated: 2022-08-23
 * Version: 4.5.4
 */

!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?e(exports):"function"==typeof define&&define.amd?define(["exports"],e):e((t="undefined"!=typeof globalThis?globalThis:t||self).easytimer={})}(this,(function(t){"use strict";function e(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function n(t){for(var n=1;n<arguments.length;n++){var r=null!=arguments[n]?arguments[n]:{};n%2?e(Object(r),!0).forEach((function(e){o(t,e,r[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(r)):e(Object(r)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(r,e))}))}return t}function r(t){return(r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function o(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function s(t,e,n){var r,o="";if((t="number"==typeof t?String(t):t).length>e)return t;for(r=0;r<e;r+=1)o+=String(n);return(o+t).slice(-o.length)}function i(){this.reset()}function u(){this.events={}}i.prototype.toString=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:["hours","minutes","seconds"],e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:":",n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:2;t=t||["hours","minutes","seconds"],e=e||":",n=n||2;var r,o=[];for(r=0;r<t.length;r+=1)void 0!==this[t[r]]&&("secondTenths"===t[r]?o.push(this[t[r]]):o.push(s(this[t[r]],n,"0")));return o.join(e)},i.prototype.reset=function(){this.secondTenths=0,this.seconds=0,this.minutes=0,this.hours=0,this.days=0},u.prototype.on=function(t,e){var n=this;return Array.isArray(this.events[t])||(this.events[t]=[]),this.events[t].push(e),function(){return n.removeListener(t,e)}},u.prototype.removeListener=function(t,e){if(Array.isArray(this.events[t])){var n=this.events[t].indexOf(e);n>-1&&this.events[t].splice(n,1)}},u.prototype.removeAllListeners=function(t){t?Array.isArray(this.events[t])&&(this.events[t]=[]):this.events={}},u.prototype.emit=function(t){for(var e=this,n=arguments.length,r=new Array(n>1?n-1:0),o=1;o<n;o++)r[o-1]=arguments[o];Array.isArray(this.events[t])&&this.events[t].forEach((function(t){return t.apply(e,r)}))};var c=10,a=60,f=60,h=24,d="secondTenths",l="seconds",p="minutes",v="hours",y="days",m=[d,l,p,v,y],b={secondTenths:100,seconds:1e3,minutes:6e4,hours:36e5,days:864e5},g={secondTenths:c,seconds:a,minutes:f,hours:h};function w(t,e){return(t%e+e)%e}function O(){var t,e,o,s,O,T,j,A,E,P,S=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},D=new i,L=new i,x=new u,V=!1,M=!1,U={},k={detail:{timer:this}};function I(t,e){var n=g[t];L[t]=e,D[t]=t===y?Math.abs(e):w(e>=0?e:n-w(e,n),n)}function _(t){return B(t,y)}function z(t){return B(t,v)}function C(t){return B(t,p)}function R(t){return B(t,l)}function q(t){return B(t,d)}function B(t,e){var n=L[e];return I(e,rt(t,b[e])),L[e]!==n}function F(){G(),Z()}function G(){clearInterval(t),t=void 0,V=!1,M=!1}function H(t){yt()?(E=K(),T=ot(O.target)):$(t),J()}function J(){var n=b[e];Y(W(Date.now()))||(t=setInterval(N,n),V=!0,M=!1)}function K(){return W(Date.now())-L.secondTenths*b.secondTenths*o}function N(){var t=W(Date.now());X(Q()),s(k.detail.timer),Y(t)&&(ut(),pt("targetAchieved",k))}function Q(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:W(Date.now()),e=o>0?t-E:E-t,n={};return n.secondTenths=q(e),n.seconds=R(e),n.minutes=C(e),n.hours=z(e),n.days=_(e),n}function W(t){return Math.floor(t/b[e])*b[e]}function X(t){t.secondTenths&&pt("secondTenthsUpdated",k),t.seconds&&pt("secondsUpdated",k),t.minutes&&pt("minutesUpdated",k),t.hours&&pt("hoursUpdated",k),t.days&&pt("daysUpdated",k)}function Y(t){return T instanceof Array&&t>=P}function Z(){D.reset(),L.reset()}function $(t){e=tt((t=t||{}).precision),s="function"==typeof t.callback?t.callback:function(){},A=!0===t.countdown,o=!0===A?-1:1,"object"===r(t.startValues)?st(t.startValues):j=null,E=K(),Q(),"object"===r(t.target)?T=ot(t.target):A?(t.target={seconds:0},T=ot(t.target)):T=null,U={precision:e,callback:s,countdown:"object"===r(t)&&!0===t.countdown,target:T,startValues:j},O=t}function tt(t){if(!et(t="string"==typeof t?t:l))throw new Error("Error in precision parameter: ".concat(t," is not a valid value"));return t}function et(t){return m.indexOf(t)>=0}function nt(t){var e;if("object"===r(t))if(t instanceof Array){if(5!==t.length)throw new Error("Array size not valid");e=t}else{for(var n in t)if(m.indexOf(n)<0)throw new Error("Error in startValues or target parameter: ".concat(n," is not a valid input value"));e=[t.secondTenths||0,t.seconds||0,t.minutes||0,t.hours||0,t.days||0]}var o=(e=e.map((function(t){return parseInt(t,10)})))[0],s=e[1]+rt(o,c),i=e[2]+rt(s,a),u=e[3]+rt(i,f),d=e[4]+rt(u,h);return e[0]=o%c,e[1]=s%a,e[2]=i%f,e[3]=u%h,e[4]=d,e}function rt(t,e){var n=t/e;return n<0?Math.ceil(n):Math.floor(n)}function ot(t){if(t){var e=it(T=nt(t));return P=E+e.secondTenths*b.secondTenths*o,T}}function st(t){j=nt(t),D.secondTenths=j[0],D.seconds=j[1],D.minutes=j[2],D.hours=j[3],D.days=j[4],L=it(j,L)}function it(t,e){var n=e||{};return n.days=t[4],n.hours=n.days*h+t[3],n.minutes=n.hours*f+t[2],n.seconds=n.minutes*a+t[1],n.secondTenths=n.seconds*c+t[[0]],n}function ut(){F(),pt("stopped",k)}function ct(){F(),H(O),pt("reset",k)}function at(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};t=n(n({},S),t),vt()||(H(t),pt("started",k))}function ft(){G(),M=!0,pt("paused",k)}function ht(t,e){x.on(t,e)}function dt(t,e){x.removeListener(t,e)}function lt(t){x.removeAllListeners(t)}function pt(t,e){x.emit(t,e)}function vt(){return V}function yt(){return M}function mt(){return D}function bt(){return L}function gt(){return U}$(S),void 0!==this&&(this.start=at,this.pause=ft,this.stop=ut,this.reset=ct,this.isRunning=vt,this.isPaused=yt,this.getTimeValues=mt,this.getTotalTimeValues=bt,this.getConfig=gt,this.addEventListener=ht,this.on=ht,this.removeEventListener=dt,this.removeAllEventListeners=lt,this.off=dt)}t.Timer=O,t.default=O,Object.defineProperty(t,"__esModule",{value:!0})}));

const timer60 = new easytimer.Timer();
let cartItemsCount = 0;
let cartTimerStarted = false;

// Function to load saved timer state from localStorage
function loadTimerState(timer, timerId, defaultTimeInSeconds, cartItemsCount) {
  // Don't initialize timer for pre-shop users
  if (isPreShopUser()) return;
  
  let timerState = JSON.parse(localStorage.getItem(timerId));
  if (timerState) {
      let elapsedTime = Math.floor((Date.now() - timerState.timestamp) / 1000);
      let remainingTime = timerState.timeLeft - elapsedTime;
      if (remainingTime > 0) {
          setTimeout(() => startTimer(timer, remainingTime), 500);
      } else {
          setTimeout(() => resetTimer(timer, timerId, defaultTimeInSeconds), 500);
      }
  } else {
      setTimeout(() => resetTimer(timer, timerId, defaultTimeInSeconds), 500);
      // Automatically start the timer if items exist in the cart
      if (cartItemsCount > 0) {
          setTimeout(() => startTimer(timer, defaultTimeInSeconds), 500);
      }
  }
}

// Cookie utility functions for pre-shop
function preShopSetCookie(name, value, days) {
  const d = new Date();
  d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = "expires=" + d.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

function preShopGetCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function isPreShopUser() {
  // Try localStorage first, then fall back to cookie
  const fromLocalStorage = localStorage.getItem('preShopUser') === 'true';
  const fromCookie = preShopGetCookie('preShopUser') === 'true';
  
  // Also check the signup cookie directly as a fallback
  const fromSignupCookie = document.cookie.split(';').some(item => {
    return item.trim().startsWith('preShopUser=true');
  });
  
  return (fromLocalStorage || fromCookie || fromSignupCookie) && 
         window.theme && window.theme.preShopActive === true;
}

// Function to set pre-shop flag when visiting pre-shop pages
function setPreShopCookie() {
  // Only set pre-shop state if pre-shop is active in theme settings
  if (window.theme && window.theme.preShopActive) {
    localStorage.setItem('preShopUser', 'true');
    preShopSetCookie('preShopUser', 'true', 30); // Store for 30 days
    // Notify other components about the change
    notifyPreShopStateChanged(true);
  }
}

// Function to clear pre-shop state
function clearPreShopState() {
  localStorage.removeItem('preShopUser');
  preShopSetCookie('preShopUser', '', -1); // Expire cookie
  // Notify other components about the change
  notifyPreShopStateChanged(false);
}

// Function to notify other components about pre-shop state changes
function notifyPreShopStateChanged(isPreShop) {
  document.dispatchEvent(new CustomEvent('pre-shop:updated', {
    detail: { isPreShop }
  }));
}

timer60.addEventListener('secondsUpdated', function (e) {
    if (isPreShopUser()) return;
    
    let remainingTime = timer60.getTotalTimeValues().seconds;
    const timerElement = document.getElementById("timer60");
    if (timerElement) {
        timerElement.innerHTML = String(timer60.getTimeValues().minutes).padStart(2, "0") + ":" + String(timer60.getTimeValues().seconds).padStart(2, "0");
        localStorage.setItem("timer60", JSON.stringify({ timeLeft: remainingTime, timestamp: Date.now() }));
    }
});

timer60.addEventListener('targetAchieved', function (e) {
    if (isPreShopUser()) return;
    
    resetTimer(timer60, "timer60", 3600);
    startTimer(timer60, 3600);
});

// Function to reset the timer
function resetTimer(timer, timerId, defaultTimeInSeconds) {
    if (isPreShopUser()) return;
    
    if (timer) {
        timer.stop();
    }

    if (timerId) {
        localStorage.removeItem(timerId);
    }
}

// Function to start the timer
function startTimer(timer, timeInSeconds) {
    if (isPreShopUser()) return;
    
    timer.start({ countdown: true, startValues: { seconds: timeInSeconds }});
}

// Check if the cart is empty and reset the timer if necessary
function resetTimerIfCartEmpty() {
    if (isPreShopUser()) return;
    resetTimer(timer60, "timer60", 3600);
}

// Function to initialize pre-shop message slider
function initPreShopMessageSlider() {
  if ($('.pre-shop-message-slider').length && !$('.pre-shop-message-slider').hasClass('slick-initialized')) {
    $(".pre-shop-message-slider").slick({
      dots: false,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: false,
      fade: false,
      infinite: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      easing: "ease",
      vertical: true,
    }).on('afterChange', function(event, slick, currentSlide) {
      // Check if the active slide has a class of "red-slide"
      const activeSlide = $('.pre-shop-message-slider .slick-current');
      if (activeSlide.hasClass('red-slide')) {
        // Add red-slide-active class to mini-cart if active slide has red-slide class
        $('.mini-cart').addClass('red-slide-active');
      } else {
        // Remove red-slide-active class if active slide doesn't have red-slide class
        $('.mini-cart').removeClass('red-slide-active');
      }
    });
  }
}

// Function to handle cart display updates
function updateCartDisplay() {
  const isPreShop = isPreShopUser();
  const messageContainer = document.querySelector('[data-message-container]');
  const miniCart = document.querySelector('.mini-cart');
  
  if (isPreShop) {
    // Set localStorage if on pre-shop page
    if (window.location.pathname.includes('pre-shop')) {
      localStorage.setItem('preShopUser', 'true');
      preShopSetCookie('preShopUser', 'true', 30); // Store for 30 days
    }
    
    // Add pre-shop classes
    document.body.classList.add('pre-shop-area');
    miniCart.classList.add('pre-shop-cart');
    
    // Load pre-shop messages
    const preShopTemplate = document.getElementById('pre-shop-messages');
    if (preShopTemplate && messageContainer) {
      messageContainer.innerHTML = preShopTemplate.innerHTML;
      
      // Initialize slider after content is loaded
      setTimeout(function() {
        initPreShopMessageSlider();
      }, 100);
    }
    
    // Load calendar section
    const calendarTemplate = document.getElementById('pre-shop-calendar');
    const checkoutFooter = document.querySelector('.checkout-footer');
    if (calendarTemplate && checkoutFooter) {
      // Check if calendar is already added
      if (!checkoutFooter.querySelector('.mini-cart-pre-shop')) {
        checkoutFooter.insertAdjacentHTML('afterbegin', calendarTemplate.innerHTML);
      }
    }
    
    // Initialize pre-shop specific functionality
    if (typeof getLocalLaunchTimeCart === 'function') {
      document.querySelectorAll('.event-launch-time').forEach(element => {
        element.textContent = getLocalLaunchTimeCart();
      });
    }

    // Stop any existing timer
    resetTimer(timer60, "timer60", 3600);
    cartTimerStarted = false;
  } else {
    // Load standard messages
    const standardTemplate = document.getElementById('standard-messages');
    if (standardTemplate && messageContainer) {
      messageContainer.innerHTML = standardTemplate.innerHTML;
    }
    
    // Remove pre-shop classes if they exist
    document.body.classList.remove('pre-shop-area');
    miniCart.classList.remove('pre-shop-cart');
    
    // Remove any pre-shop elements
    const preShopElements = miniCart.querySelectorAll('.mini-cart-pre-shop, .tooltip-popup');
    preShopElements.forEach(element => {
      element.remove();
    });

    // Remove red-slide-active class if it exists
    miniCart.classList.remove('red-slide-active');

    // Handle timer for non-pre-shop users
    if (useCartTimer && !cartTimerStarted && cartItemsCount > 0) {
      if (initialCartLoad) {
        loadTimerState(timer60, "timer60", 3600, cartItemsCount);
      } else {
        startTimer(timer60, 3600);
      }
      cartTimerStarted = true;
    }
  }
}

// Function to add pre-shop navigation elements
function addPreShopNavElements() {
    // Pre-shop GIF URLs
    const preShopGifUrl1 = 'https://cdn.shopify.com/s/files/1/2422/6603/files/PE2025-Preshop-Nav_3.gif?v=1742507626';
    const preShopGifUrl2 = 'https://cdn.shopify.com/s/files/1/2422/6603/files/PE2025-Preshop-Nav-2.gif?v=1742507626';
    
    // First, remove any existing pre-shop navigation elements
    const existingDesktopIcon = document.querySelector('.pre-shop-nav-icon');
    if (existingDesktopIcon) {
        existingDesktopIcon.remove();
    }
    
    const existingMobileIcon = document.querySelector('.mobile-dropdown-pre-shop');
    if (existingMobileIcon) {
        existingMobileIcon.remove();
    }
    
    // Determine the URL based on pre-shop status
    const targetUrl = isPreShopUser() ? '/collections/pre-shop' : '/pages/sale-signup-2025';
    
    // Update announcement bar if user is pre-shop
    const announcementBar = document.querySelector('.announcement-bar');
    if (announcementBar && isPreShopUser()) {
        // Update desktop CTA
        const desktopBannerCta = announcementBar.querySelector('.top-banner-cta.top-banner-cta-desktop');
        if (desktopBannerCta) {
            desktopBannerCta.textContent = "FILL YOUR CART";
            desktopBannerCta.classList.add('top-banner-cta-show');
        }
        
        // Update mobile CTA
        const mobileBannerCta = announcementBar.querySelector('.top-banner-cta.top-banner-cta-mobile');
        if (mobileBannerCta) {
            mobileBannerCta.textContent = "FILL YOUR CART";
            mobileBannerCta.classList.add('top-banner-cta-show');
        }
        
        // Update the link
        const announcementLink = announcementBar.querySelector('.announcement-bar__link');
        if (announcementLink) {
            announcementLink.href = "/collections/pre-shop";
        }
    } else {
        const desktopBannerCta = announcementBar.querySelector('.top-banner-cta.top-banner-cta-desktop');
        if (desktopBannerCta) {
            desktopBannerCta.classList.add('top-banner-cta-show');
        }
        
        // Update mobile CTA
        const mobileBannerCta = announcementBar.querySelector('.top-banner-cta.top-banner-cta-mobile');
        if (mobileBannerCta) {
            mobileBannerCta.classList.add('top-banner-cta-show');
        }
    }
    // For desktop: add to .header__icons
    const headerIcons = document.querySelector('.header__icons');
    if (headerIcons && !headerIcons.querySelector('.pre-shop-nav-icon')) {
        const desktopNavLink = document.createElement('a');
        desktopNavLink.href = targetUrl;
        desktopNavLink.className = 'pre-shop-nav-icon';
        desktopNavLink.setAttribute('data-gtm-dynamic-click', 'true');
        desktopNavLink.setAttribute('data-gtm-category', 'Desktop Navigation');
        desktopNavLink.setAttribute('data-gtm-action', 'Pre-Shop Link');
        desktopNavLink.setAttribute('data-gtm-label', 'PRE-SHOP');
        
        // Add the first image
        const desktopImg1 = document.createElement('img');
        desktopImg1.src = preShopGifUrl1;
        desktopImg1.alt = 'Sale Pre-Shop';
        desktopImg1.className = 'pre-shop-nav-image-1';
        
        // Add the second image
        const desktopImg2 = document.createElement('img');
        desktopImg2.src = preShopGifUrl2;
        desktopImg2.alt = 'Sale Pre-Shop';
        desktopImg2.className = 'pre-shop-nav-image-2';
        
        // Append both images to the link
        desktopNavLink.appendChild(desktopImg1);
        desktopNavLink.appendChild(desktopImg2);
        
        headerIcons.prepend(desktopNavLink);
    }
    
    // For mobile: add to .mobile-navbar-tab-trigger
    const mobileNavbar = document.querySelector('.mobile-navbar-tab-trigger');
    if (mobileNavbar && !mobileNavbar.querySelector('.mobile-dropdown-pre-shop')) {
        const mobileNavItem = document.createElement('li');
        mobileNavItem.className = 'mobile-navbar-trigger mobile-nav-index-1 mobile-dropdown-pre-shop';
        
        mobileNavItem.innerHTML = `   
            <a href="${targetUrl}" class="mobile-navbar-normal-link" data-gtm-dynamic-click="true" data-gtm-category="Mobile Navigation" data-gtm-action="Main Link" data-gtm-label="PRE-SHOP" data-gtm-initialized="true">
            <img src="${preShopGifUrl2}" alt="Sale Pre-Shop" />
            </a>
        `;
        
        mobileNavbar.prepend(mobileNavItem);
    }
}

// Flag to track initialization
let cartDrawerInitialized = false;

// Event listeners for cart updates
document.addEventListener('DOMContentLoaded', function() {
    // Prevent multiple initializations
    if (cartDrawerInitialized) return;
    cartDrawerInitialized = true;
    
    // Initialize cart display with pre-shop state

    updateCartDisplay();
    addPreShopNavElements();


});

// Listen for successful signup
document.addEventListener('signup:success', function() {
    // When a user signs up successfully, update the cart display
    setTimeout(function() {
        updateCartDisplay();
        addPreShopNavElements();
        // Trigger a cart refresh event to ensure everything is updated
        document.dispatchEvent(new CustomEvent('cart:refresh'));
    }, 500);
});

// Listen for pre-shop state changes
document.addEventListener('pre-shop:updated', function(event) {
    const isPreShop = event.detail && event.detail.isPreShop;
    console.log('Pre-shop state updated:', isPreShop);
    
    // Update pre-shop elements
    if (isPreShop) {
        addPreShopNavElements();
    } else {
        // If pre-shop was deactivated, remove pre-shop elements
        document.body.classList.remove('pre-shop-area', 'template-pdp-pre-shop');
        const miniCart = document.querySelector('.mini-cart');
        if (miniCart) {
            miniCart.classList.remove('pre-shop-cart');
            const preShopElements = miniCart.querySelectorAll('.mini-cart-pre-shop, .tooltip-popup');
            preShopElements.forEach(element => {
                element.remove();
            });
        }
    }
    
    // Update cart display
    updateCartDisplay();
});

// Handle cart refresh/update events
document.addEventListener('cart:refresh', function() {
  updateCartDisplay();
});

const useCartTimer = window.theme.cart_timer_active;


if (window.theme.isSaleActive || window.theme.gwp_active) {
    // Confetti - modified from: https://github.com/daniel-lundin/dom-confetti
    var defaultColors2 = [
        window.theme.confetti_color_1,
        window.theme.confetti_color_2,
        window.theme.confetti_color_3,
    ];

    function createElements(root, elementCount, colors, width, height) {
        return Array.from({
            length: elementCount,
        }).map(function (_, index) {
            var element = document.createElement('div');
            var color = colors[index % colors.length];
            element.style['background-color'] = color; // eslint-disable-line space-infix-ops

            element.style.width = width;
            element.style.height = height;
            element.style.position = 'absolute';
            element.style.willChange = 'transform, opacity';
            element.style.visibility = 'hidden';
            root.appendChild(element);
            return element;
        });
    }

    function randomPhysics(angle, spread, startVelocity, random) {
        var radAngle = angle * (Math.PI / 180);
        var radSpread = spread * (Math.PI / 180);
        return {
            x: 0,
            y: 0,
            z: 0,
            wobble: random() * 10,
            wobbleSpeed: 0.1 + random() * 0.1,
            velocity: startVelocity * 0.5 + random() * startVelocity,
            angle2D: -radAngle + (0.5 * radSpread - random() * radSpread),
            angle3D: -(Math.PI / 4) + random() * (Math.PI / 2),
            tiltAngle: random() * Math.PI,
            tiltAngleSpeed: 0.1 + random() * 0.3,
        };
    }

    function updateFetti(fetti, progress, dragFriction, decay) {
        /* eslint-disable no-param-reassign */
        fetti.physics.x += Math.cos(fetti.physics.angle2D) * fetti.physics.velocity;
        fetti.physics.y += Math.sin(fetti.physics.angle2D) * fetti.physics.velocity;
        fetti.physics.z += Math.sin(fetti.physics.angle3D) * fetti.physics.velocity;
        fetti.physics.wobble += fetti.physics.wobbleSpeed; // Backward compatibility

        if (decay) {
            fetti.physics.velocity *= decay;
        } else {
            fetti.physics.velocity -= fetti.physics.velocity * dragFriction;
        }

        fetti.physics.y += 3;
        fetti.physics.tiltAngle += fetti.physics.tiltAngleSpeed;
        var _fetti$physics = fetti.physics;
        var x = _fetti$physics.x;
        var y = _fetti$physics.y;
        var z = _fetti$physics.z;
        var tiltAngle = _fetti$physics.tiltAngle;
        var wobble = _fetti$physics.wobble;

        var wobbleX = x + 10 * Math.cos(wobble);
        var wobbleY = y + 10 * Math.sin(wobble);
        var transform =
            'translate3d(' +
            wobbleX +
            'px, ' +
            wobbleY +
            'px, ' +
            z +
            'px) rotate3d(1, 1, 1, ' +
            tiltAngle +
            'rad)';
        fetti.element.style.visibility = 'visible';
        fetti.element.style.transform = transform;
        fetti.element.style.opacity = 1 - progress;
        /* eslint-enable */
    }

    function animate(root, fettis, dragFriction, decay, duration, stagger) {
        var startTime = void 0;
        return new Promise(function (resolve) {
            function update(time) {
                if (!startTime) startTime = time;
                var elapsed = time - startTime;
                var progress = startTime === time ? 0 : (time - startTime) / duration;
                fettis.slice(0, Math.ceil(elapsed / stagger)).forEach(function (fetti) {
                    updateFetti(fetti, progress, dragFriction, decay);
                });

                if (time - startTime < duration) {
                    requestAnimationFrame(update);
                } else {
                    fettis.forEach(function (fetti) {
                        if (fetti.element.parentNode === root) {
                            return root.removeChild(fetti.element);
                        }
                    });
                    resolve();
                }
            }

            requestAnimationFrame(update);
        });
    }

    var defaults2 = {
        angle: 90,
        spread: 45,
        startVelocity: 45,
        elementCount: 50,
        width: '10px',
        height: '10px',
        perspective: '',
        colors: defaultColors2,
        duration: 3000,
        stagger: 0,
        dragFriction: 0.1,
        random: Math.random,
    };

    function backwardPatch(config) {
        if (!config.stagger && config.delay) {
            config.stagger = config.delay;
        }

        return config;
    }

    window.cartConfetti = function (root) {
        var config = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

        var _Object$assign = Object.assign({}, defaults2, backwardPatch(config));

        var elementCount = _Object$assign.elementCount;
        var colors = _Object$assign.colors;
        var width = _Object$assign.width;
        var height = _Object$assign.height;
        var perspective = _Object$assign.perspective;
        var angle = _Object$assign.angle;
        var spread = _Object$assign.spread;
        var startVelocity = _Object$assign.startVelocity;
        var decay = _Object$assign.decay;
        var dragFriction = _Object$assign.dragFriction;
        var duration = _Object$assign.duration;
        var stagger = _Object$assign.stagger;
        var random = _Object$assign.random;

        root.style.perspective = perspective;
        var elements = createElements(root, elementCount, colors, width, height);
        var fettis = elements.map(function (element) {
            return {
                element: element,
                physics: randomPhysics(angle, spread, startVelocity, random),
            };
        });
        return animate(root, fettis, dragFriction, decay, duration, stagger);
    };
}

const gwp_active = window.theme.gwp_active;
const gwp_type = window.theme.gwp_type;
const gwp_product = window.theme.gwp_product;

$(document).ready(function () {
    if (window.theme.isSaleActive) {
        function cartConfetti(e) {
            // Burst of celebratory confetti!
            window.cartConfetti(document.getElementById('confetti-canvas2'), {
                angle: 90,
                spread: 180,
                startVelocity: 40,
                elementCount: 50,
                decay: 0.7,
            });
        }
    }

    
    function miniCartDisableBackgroundTabIndexes() {}

    function miniCartRestoreBackgroundTabIndexes() {}

    function mixpanelBagViewed() {
        //console.log('Bag viewed');
        var currentPageURL = window.location.href;
        var totalPriceFormatted;
        $.ajax({
            url: '/cart.js',
            dataType: 'json',
            success: function (cartData) {
                totalPriceFormatted = (cartData.total_price / 100).toFixed(2);
                mixpanel.track('Bag Viewed', {
                    URL: currentPageURL,
                    Subtotal: totalPriceFormatted,
                    Total_Items: cartData.item_count,
                });
            },
            error: function (xhr, status, error) {
                console.error('Error fetching cart data:', error);
            },
        });
    }

    function mixpanelAddToCartPDP(itemData, currency, Lens) {
        mixpanel.track('Added to Cart', {
            data: itemData,
            Currency: currency,
            Source: 'Product page',
            Lens: Lens,
        });
    }

    $(document).on('click', '.header__icon--cart', function (e) {
        e.preventDefault();
        $('body').addClass('mini-cart-open');
        prioritizeCartTabIndex();
        miniCartDisableBackgroundTabIndexes();

        if (typeof mixpanel !== 'undefined') {
            mixpanelBagViewed();
        }
    });

    const debounceInput = (callback, wait) => {
        let timeoutId = null;
        return (...args) => {
            window.clearTimeout(timeoutId);
            timeoutId = window.setTimeout(() => {
                callback.apply(null, args);
            }, wait);
        };
    };

    var ffToteVariantID = 40212306362455;

    $(document).on('click', '.gift-message-header', function () {
        var $this = $(this);
        $this.parents('.gift-message--wrapper').toggleClass('show-gift-message');
    });
});

var maxLength = 125;
$('#giftmessage').keyup(function () {
    var length = $(this).val().length;
    var length = maxLength - length;
    $('.character-counter').text(length);
});

///////////////////////////////////////////////////////////////////////////////
///// Check if there's a tote in the cart
///////////////////////////////////////////////////////////////////////////////
if ($('body').hasClass('template-cart')) {
    var cartBody = '.cart-body';
    var cartItemLine = '.cart-item';
    var cartItemRemove = '.cart-item-remove';
    var cartItemProperties = '.cart-item-properties';
} else {
    var cartBody = '.mini-cart-body';
    var cartItemLine = '.mini-cart-item';
    var cartItemRemove = '.mini-cart-item-remove';
    var cartItemProperties = '.mini-cart-item-properties';
}

document.addEventListener('Loop:Cart Update', () => {
    CartJS.setNote('');
});

$(document).click(function (event) {
    if (
        $('.localization-selector').hasClass('view-currencies') &&
        $(event.target).closest('.localization-selector').length == 0
    ) {
        $('.localization-selector').removeClass('view-currencies');
        $('header #CountryList .disclosure__link').each(function () {
            var $this = $(this);
            $this.attr('tabindex', '-1');
        });
    }
});

$(document).on('click', '.localization-selector', function () {
    $('.localization-selector').toggleClass('view-currencies');
    $('header #CountryList .disclosure__link').each(function () {
        var $this = $(this);
        $this.attr('tabindex', '0');
    });
});

function prioritizeCartTabIndex() {

    // Select all elements in the mini-cart that need tabindex changes
    const miniCartElements = document.querySelectorAll('.mini-cart, .mini-cart button, .mini-cart a, .mini-cart input');
    
    // Loop through each mini-cart element and set tabindex to '1'
    miniCartElements.forEach(element => {
        element.setAttribute('tabindex', '1');
    });
    
    // Select the mini-cart close button
    const closeButton = document.querySelector('.mini-cart button.mini-cart-close');
    
    if (closeButton) {
        // Focus the close button
        closeButton.focus();
    } else {
        //console.log('Mini-cart close button not found');
    }
    
}

function decreaseCartTabIndex() {
    $('.mini-cart, .mini-cart button, .mini-cart a, .mini-cart input').each(function () {
        $(this).attr('tabindex', '-1');
    });
}


const miniAccount = document.querySelector('.mini-account');
const loginFormMini = document.querySelector('.mini-account-login');
const registerFormMini = document.querySelector('.mini-account-register');

miniAccount.addEventListener('click', function (event) {
    if (event.target.classList.contains('mini-account-register-trigger')) {
        loginFormMini.style.display = 'none';
        registerFormMini.style.display = 'block';
    } else if (event.target.classList.contains('mini-account-login-trigger')) {
        loginFormMini.style.display = 'block';
        registerFormMini.style.display = 'none';
    }
});

document.addEventListener('keyup', function (event) {
    if (event.key === 'Escape') {
        if ($('body').hasClass('mini-cart-open')) {
            decreaseCartTabIndex();
        }
    }
});

let initialCartLoad = false;
let backButtonCartLoad = false;

document.addEventListener('DOMContentLoaded', function (event) {
    initialCartLoad = true;
    renderMiniCart(initialCartLoad);
    initialCartLoad = false;
});

document.addEventListener('keydown', function (event) {
    if (event.key === 'Tab') {
        document.body.classList.add('keyboard-focus');
    }
});

document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
        document.body.classList.remove('keyboard-focus');
    }
});

let frameCaseID = $('#frameCase').attr('data-frame-id');
frameCaseID = parseInt(frameCaseID, 10);
let frameCaseProperties = {};

if (window.theme.isSaleActive) {
    frameCaseProperties = {
        Frame: 'FINAL SALE',
    };
}

let show_sale_elements = false;
let in_your_cart = false;
let buyNowButtonClick = false;
let has_unique_labels = true;
if (
    (window.theme.preShopActive && $('body').hasClass('pre-shop-area')) ||
    window.theme.isSaleActive
) {
    show_sale_elements = true;
}

if (
    window.theme.preShopActive &&
    $('body').hasClass('pre-shop-area') &&
    $('body').hasClass('template-collection-brand-blocks')
) {
    in_your_cart = true;
}

$(document).on('click', '.mini-cart-close, .mini-cart-overlay', function () {
    $('body').removeClass('mini-cart-open');
    decreaseCartTabIndex();
    miniCartRestoreBackgroundTabIndexes();

    if ($('body').hasClass('template-product') && $('body').hasClass('keyboard-focus')) {
        $('.header__icon--cart').focus();
    }
});

document.addEventListener('DOMContentLoaded', function () {
   
    if (!$('body').hasClass('template-product')) {
        document.body.addEventListener('click', function (e) {
            // Check if the clicked element or any of its parents have the .addToCart class
            if (e.target.matches('.addToCart') || e.target.closest('.addToCart')) {
                let targetElement = e.target.closest('.addToCart');

                if (targetElement && !targetElement.classList.contains('item-in-cart')) {
                    const variantId = targetElement.getAttribute('data-variant-id');
                    let formData;
                    let properties = {};
                    let variantPropertiesLens;


                    frameCaseID = parseInt(targetElement.getAttribute('data-frame-case-id'), 10);

                    // Loop through all data attributes to find those relevant to line properties
                    Object.keys(targetElement.dataset).forEach((key) => {
                        if (key.startsWith('lineProperty')) {
                            let propName = key.replace('lineProperty', '').replace('Hidden', '');
                            propName = propName.charAt(0).toLowerCase() + propName.slice(1); // Convert first char to lower case

                            // Check for hidden properties and prepend an underscore
                            if (key.includes('Hidden')) {
                                propName = '_' + propName.toLowerCase();
                            } else if (propName.toLowerCase() !== 'id') {
                                // Capitalize the first letter of propName if it's not a hidden property or "id"
                                propName =
                                    propName.charAt(0).toUpperCase() +
                                    propName.slice(1).toLowerCase();
                            }

                            const value = targetElement.dataset[key];

                            // Only add the property if it's not empty or "false"
                            if (value && value.toLowerCase() !== 'false') {
                                properties[propName] = value;
                            }
                        }
                    });
                    //console.log('properties:', properties);

                    if (this.classList.contains('pre-order-atb')) {
                        properties = {
                            'Pre-Order': $('.pdp-preorder-date .krw--desktop-only').text(),
                        };
                    }

                    if (targetElement.getAttribute('data-include-frame-case') === 'true') {
                        if (
                            targetElement.getAttribute('data-hidden-add-on') !== null &&
                            targetElement.getAttribute('data-hidden-add-on') !== ''
                        ) {
                            formData = {
                                items: [
                                    {
                                        id: frameCaseID,
                                        quantity: 1,
                                        properties: frameCaseProperties,
                                    },
                                    {
                                        id: parseInt(
                                            targetElement.getAttribute('data-hidden-add-on'),
                                            10,
                                        ),
                                        quantity: 1,
                                        properties: frameCaseProperties,
                                    },
                                    {
                                        id: variantId,
                                        quantity: 1,
                                        properties: properties,
                                    },
                                ],
                            };
                        } else {
                            formData = {
                                items: [
                                    {
                                        id: frameCaseID,
                                        quantity: 1,
                                        properties: frameCaseProperties,
                                    },
                                    {
                                        id: variantId,
                                        quantity: 1,
                                        properties: properties,
                                    },
                                ],
                            };
                        }
                    } else {
                        if (
                            targetElement.getAttribute('data-hidden-add-on') !== null &&
                            targetElement.getAttribute('data-hidden-add-on') !== ''
                        ) {
                            formData = {
                                items: [
                                    {
                                        id: parseInt(
                                            targetElement.getAttribute('data-hidden-add-on'),
                                            10,
                                        ),
                                        quantity: 1,
                                        properties: properties,
                                    },
                                    {
                                        id: variantId,
                                        quantity: 1,
                                        properties: properties,
                                    },
                                ],
                            };
                        } else {
                            formData = {
                                items: [
                                    {
                                        id: variantId,
                                        quantity: 1,
                                        properties: properties,
                                    },
                                ],
                            };
                        }
                    }

                    //console.log('formData:', formData);

                    fetch(window.Shopify.routes.root + 'cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(formData),
                    })
                        .then((response) => response.json())
                        .then((data) => {
                            // if body class contains 'pre-shop-area' in vanilla JS

                            
                                //targetElement.classList.add('item-in-cart');
                                const cardWrapper = targetElement.closest('.card-wrapper');
                                if (cardWrapper) {
                                    cardWrapper.classList.add('in-cart');
                                }

                                // Find all .button-to-update elements within the cardWrapper and update their HTML
                                const buttonsToUpdate =
                                    cardWrapper.querySelectorAll('.button-to-update');
                                buttonsToUpdate.forEach((button) => {
                                    
                                    button.innerHTML =
                                        '<span class="item-added-state"><svg class="icon-checkmark-atb" xmlns="http://www.w3.org/2000/svg" width="7" height="6" viewBox="0 0 7 6" fill="none"><path d="M5.90955 1.67142L2.57942 5.23941L1.15222 3.90141" stroke="white" stroke-miterlimit="10" stroke-linecap="square" /></svg> In Your Cart</span>';
                            
                                    button.classList.add('item-in-cart');
                                });
                            
                            renderMiniCart(initialCartLoad, in_your_cart, backButtonCartLoad);

                            // Klaviyo tracking
                            
                            if (typeof klaviyo !== 'undefined') {
                                let item = {
                                    "ProductName": targetElement.getAttribute('data-product-full-name'),
                                    "ProductID": parseInt(targetElement.getAttribute('data-product-id')),
                                    "Categories": targetElement.getAttribute('data-product-type'),
                                    "SKU": targetElement.getAttribute('data-product-sku'),
                                    "ImageURL": targetElement.getAttribute('data-product-featured-image'),
                                    "URL": targetElement.getAttribute('data-product-url'),
                                    "Brand": "KREWE",
                                    "Price": targetElement.getAttribute('data-product-price'),
                                    "CompareAtPrice": targetElement.getAttribute('data-compare-at-price')
                                };

                                _learnq.push(['track', 'Added to Cart', item]);

                                //console.log(item)
                            } 
                            

                            var currentUrl = window.location.href;
                            // Get the latest item from the cart
                            var latestItem = data.items[0];
                            // Extract required data from the latest item
                            var itemData = {
                                title: latestItem.title,
                                price: (latestItem.price / 100).toFixed(2),
                                quantity: latestItem.quantity,
                                url: latestItem.url,
                                onSale: latestItem.total_discount > 0 ? true : false,
                            };
                            if (typeof mixpanel !== 'undefined') {
                                // Log extracted data in
                                mixpanel.track('Added to Cart', {
                                    data: itemData,
                                    Currency: data.currency,
                                    Source: 'Quick Add to cart',
                                    Page: currentUrl,
                                    Lens: 'No Lens',
                                });
                            }
                        })
                        .catch((error) => {
                            console.error('Error:', error);
                        });
                } else if (targetElement && targetElement.classList.contains('item-in-cart')) {
                    // Just open the mini-cart if item is already in cart
                    document.body.classList.add('mini-cart-open');
                }
            }
        });
    }
});

if (document.querySelector('#AddToCart')) {
    document.querySelector('#AddToCart').addEventListener('click', function () {
        const variantId = parseInt(this.getAttribute('data-variant-id'), 10);
        let formData;
        let properties = {};
        let variantPropertiesLens;
        let blueLightLensSwatch, blueLightReadersSwatch, Lens, mainItem;
        if ($('#frameCase:checked').length > 0) {
            if ($('.frame-case-options').length > 0) {
                const selectedFrameCase = $('.variant-hard-case').attr('data-variant-id');
                frameCaseID = parseInt(selectedFrameCase, 10);
            } else {
                frameCaseID = $('#frameCase').attr('data-frame-id');
            }
        }

        //console.log('variantID:', variantId);

        mainItem = 0;


        if (
            document.querySelector(
                '.frame-available-options button[data-variant-name="Blue Light"]',
            )
        ) {
            //console.log('Found Blue Light variant');

            blueLightLensSwatch = document.querySelector(
                '.frame-available-options button[data-variant-name="Blue Light"]',
            );

            //console.log('Current classes on blueLightLensSwatch:', blueLightLensSwatch.classList);

            // Your code here
        }

        if (
            document.querySelector(
                '.frame-available-options button[data-variant-name="Blue Light Readers"]',
            )
        ) {
            //console.log('Found Blue Light Readers variant');
            blueLightReadersSwatch = document.querySelector(
                '.frame-available-options button[data-variant-name="Blue Light Readers"]',
            );

            //console.log('Current classes on blueLightReadersSwatch:', blueLightReadersSwatch.classList);

            // Your code here
        }

        Object.keys(this.dataset).forEach((key) => {
            if (key.startsWith('lineProperty')) {
                let propName = key.replace('lineProperty', '').replace('Hidden', '');

                // Adjust the property name case based on whether it's hidden or not
                if (!key.includes('Hidden') && propName.toLowerCase() !== 'id') {
                    propName =
                        propName.charAt(0).toUpperCase() + propName.slice(1).toLowerCase();
                } else if (propName.toLowerCase() === 'id') {
                    propName = 'id';
                } else {
                    propName = '_' + propName.toLowerCase();
                }

                let value = this.dataset[key];

                // If the property name is 'id', ensure it's treated as a string
                if (propName === 'id') {
                    value = String(value); // Convert any value to string
                }

                // Only add the property if it's not empty or "false"
                if (value && value.toString().toLowerCase() !== 'false') {
                    properties[propName] = value;
                }
            }
        });

        // Blue Light is checked
        if (blueLightLensSwatch && blueLightLensSwatch.classList.contains('active-variant')) {
            let randomID = this.getAttribute('data-line-property-id');
            // Reaffirm that randomID is a string
            randomID = String(randomID);

            //console.log('Blue Light selected');
            if (this.getAttribute('data-line-property-frame') != 'FINAL SALE' && this.getAttribute('data-line-property-hidden-frame') != 'FINAL SALE') {
                variantPropertiesLens = {
                    id: randomID,
                    Frame: 'EXCHANGE ONLY',
                };
                
            } else {
                if (window.theme.preShopActive) {
                    variantPropertiesLens = {
                        id: randomID,
                        _Frame: this.getAttribute('data-line-property-hidden-frame'),
                        _preshop: 'item',
                    };
                } else {
                variantPropertiesLens = {
                    id: randomID,
                    Frame: this.getAttribute('data-line-property-frame'),
                };
                }
            }

            if (!show_sale_elements) {
                variantPropertiesLens = {
                    id: randomID,
                    Frame: 'EXCHANGE ONLY',
                    Note: 'Process time is additional 3 business days',
                };
            }
            if (this.getAttribute('data-include-frame-case') === 'true') {
                if (window.theme.preShopActive) {
                frameCaseProperties = {  
                    _Frame: 'FINAL SALE',
                    _preshop: 'item',
                    id: randomID
                };
                } else if (window.theme.isSaleActive) {
                    frameCaseProperties = {  
                        Frame: 'FINAL SALE',
                        id: randomID
                    };
                }

                formData = {
                    items: [
                        {
                            id: frameCaseID,
                            quantity: 1,
                            properties: frameCaseProperties,
                        },
                        {
                            id: 31707847557207,
                            quantity: 1,
                            properties: variantPropertiesLens,
                        },
                        {
                            id: variantId,
                            quantity: 1,
                            properties: properties,
                        },
                    ],
                };

                mainItem = 2;
            } else {
                formData = {
                    items: [
                        {
                            id: 31707847557207,
                            quantity: 1,
                            properties: variantPropertiesLens,
                        },
                        {
                            id: variantId,
                            quantity: 1,
                            properties: properties,
                        },
                    ],
                };

                mainItem = 1;
            }

            // Mixpanel
            Lens = 'Blue Light';

            //console.log('formData:', formData);

            // Blue Light Readers is checked
        } else if (
            blueLightReadersSwatch &&
            blueLightReadersSwatch.classList.contains('active-variant') &&
            blueLightReadersSwatch.classList.contains('has-readers-selected')
        ) {
            let randomID = this.getAttribute('data-line-property-id');
            // Reaffirm that randomID is a string
            randomID = String(randomID);
            let readersSelectedVariantID = parseInt(
                this.getAttribute('data-readers-selected-variant-id'),
                10,
            );

            //console.log('Readers selected');

            if (this.getAttribute('data-line-property-frame') != 'FINAL SALE' && this.getAttribute('data-line-property-hidden-frame') != 'FINAL SALE') {
                variantPropertiesLens = {
                    id: randomID,
                    Frame: 'EXCHANGE ONLY',
                };
            } else {
                if (window.theme.preShopActive) {
                    variantPropertiesLens = {
                        id: randomID,
                        _Frame: this.getAttribute('data-line-property-hidden-frame'),
                        _preshop: 'item',
                    };
                } else {
                variantPropertiesLens = {
                    id: randomID,
                    Frame: this.getAttribute('data-line-property-frame'),
                };
                }
            }

            if (!show_sale_elements) {
                variantPropertiesLens = {
                    id: randomID,
                    Frame: 'EXCHANGE ONLY',
                    Note: 'Process time is additional 3 business days',
                };
            }

            if (this.getAttribute('data-include-frame-case') === 'true') {
                
                if (window.theme.preShopActive) {
                    frameCaseProperties = {  
                        _Frame: 'FINAL SALE',
                        _preshop: 'item',
                        id: randomID
                    };
                    } else if (window.theme.isSaleActive) {
                        frameCaseProperties = {  
                            Frame: 'FINAL SALE',
                            id: randomID
                        };
                    }
                    
                   
                formData = {
                    items: [
                        {
                            id: frameCaseID,
                            quantity: 1,
                            properties: frameCaseProperties,
                        },
                        {
                            id: readersSelectedVariantID,
                            quantity: 1,
                            properties: variantPropertiesLens,
                        },
                        {
                            id: variantId,
                            quantity: 1,
                            properties: properties,
                        },
                    ],
                };

                mainItem = 2;
            } else {
                formData = {
                    items: [
                        {
                            id: readersSelectedVariantID,
                            quantity: 1,
                            properties: variantPropertiesLens,
                        },
                        {
                            id: variantId,
                            quantity: 1,
                            properties: properties,
                        },
                    ],
                };

                mainItem = 1;
            }

            // Mixpanel
            Lens = 'Blue Light Readers';

            // Normal product
        } else {
            //console.log('no readers or blue light selected');
            if (this.getAttribute('data-include-frame-case') === 'true') {
                if (
                    this.getAttribute('data-hidden-add-on') !== null &&
                    this.getAttribute('data-hidden-add-on') !== ''
                ) {
                    formData = {
                        items: [
                            {
                                id: frameCaseID,
                                quantity: 1,
                                properties: frameCaseProperties,
                            },
                            {
                                id: parseInt(this.getAttribute('data-hidden-add-on'), 10),
                                quantity: 1,
                                properties: frameCaseProperties,
                            },
                            {
                                id: variantId,
                                quantity: 1,
                                properties: properties,
                            },
                        ],
                    };

                    mainItem = 2;
                } else {
                    
                    let randomUniqueID = Math.floor(Math.random() * 9999999 + 1);

                    if (window.theme.preShopActive) {
                        frameCaseProperties = {  
                            _Frame: 'FINAL SALE',
                            _preshop: 'item',
                            id: randomUniqueID
                        };
                    } else if (window.theme.isSaleActive) {
                        frameCaseProperties = {  
                            Frame: 'FINAL SALE',
                            id: randomUniqueID
                        };
                    }


                    
                    // If randomID exists, add it to properties
                    if (randomUniqueID) {
                        properties.id = randomUniqueID;
                    }
                    formData = {
                        items: [
                            {
                                id: frameCaseID,
                                quantity: 1,
                                properties: frameCaseProperties,
                            },
                            {
                                id: variantId,
                                quantity: 1,
                                properties: properties,
                            },
                        ],
                    };

                    mainItem = 1;
                }
            } else {
                if (
                    this.getAttribute('data-hidden-add-on') !== null &&
                    this.getAttribute('data-hidden-add-on') !== ''
                ) {
                    
                    formData = {
                        items: [
                            {
                                id: parseInt(this.getAttribute('data-hidden-add-on'), 10),
                                quantity: 1,
                                properties: properties,
                            },
                            {
                                id: variantId,
                                quantity: 1,
                                properties: properties,
                            },
                        ],
                    };

                    mainItem = 1;
                } else {
                    formData = {
                        items: [
                            {
                                id: variantId,
                                quantity: 1,
                                properties: properties,
                            },
                        ],
                    };
                }
            }

            // Mixpanel
            Lens = 'No Lens Selected';
        }

        //console.log('formData final:', formData);

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then((response) => response.json())
            .then((data) => {
                renderMiniCart(initialCartLoad, in_your_cart, backButtonCartLoad);

                if (useCartTimer) {
                    startTimer(timer60, 3600);
                }

                var latestItem = data.items[mainItem];

                // Extract required data from the latest item
                var itemData = {
                    title: latestItem.product_title,
                    price: (latestItem.price / 100).toFixed(2),
                    quantity: latestItem.quantity,
                    url: latestItem.url,
                    onSale: latestItem.total_discount > 0 ? true : false,
                };
                if (typeof mixpanel !== 'undefined') {
                    // Log extracted data in
                    mixpanel.track('Added to Cart', {
                        data: itemData,
                        Currency: data.currency,
                        Source: window.theme.source,
                        Lens: Lens,
                    });
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    });
}

if (document.querySelector('#buyItNowBtn')) {
    document.querySelector('#buyItNowBtn').addEventListener('click', function () {
        const variantId = parseInt(this.getAttribute('data-variant-id'), 10);
        const frameCaseCheckbox = document.querySelector('#frameCase');
       
        let formData;
        let properties = {};
        let variantPropertiesLens;
        let blueLightLensSwatch, blueLightReadersSwatch;

        if (frameCaseCheckbox != null) {
            frameCaseID = parseInt(frameCaseCheckbox.getAttribute('data-frame-id'), 10);
        }

        //frameCaseID = parseInt(this.getAttribute('data-frame-case-id'), 10);

        //console.log('frameCaseID:', frameCaseID);

        buyNowButtonClick = true;

        let gwpProperties = {
            PROMO: 'Free with Purchase',
        }

        //console.log('variantID:', variantId);

        if (
            document.querySelector(
                '.frame-available-options button[data-variant-name="Blue Light"]',
            )
        ) {
            //console.log('Found Blue Light variant');

            blueLightLensSwatch = document.querySelector(
                '.frame-available-options button[data-variant-name="Blue Light"]',
            );

            //console.log('Current classes on blueLightLensSwatch:', blueLightLensSwatch.classList);

            // Your code here
        }

        if (
            document.querySelector(
                '.frame-available-options button[data-variant-name="Blue Light Readers"]',
            )
        ) {
            //console.log('Found Blue Light Readers variant');
            blueLightReadersSwatch = document.querySelector(
                '.frame-available-options button[data-variant-name="Blue Light Readers"]',
            );

            //console.log('Current classes on blueLightReadersSwatch:', blueLightReadersSwatch.classList);

            // Your code here
        }

        Object.keys(this.dataset).forEach((key) => {
            if (key.startsWith('lineProperty')) {
                let propName = key.replace('lineProperty', '').replace('Hidden', '');

                // Adjust the property name case based on whether it's hidden or not
                if (!key.includes('Hidden') && propName.toLowerCase() !== 'id') {
                    propName =
                        propName.charAt(0).toUpperCase() + propName.slice(1).toLowerCase();
                } else if (propName.toLowerCase() === 'id') {
                    propName = 'id';
                } else {
                    propName = '_' + propName.toLowerCase();
                }

                let value = this.dataset[key];

                // If the property name is 'id', ensure it's treated as a string
                if (propName === 'id') {
                    value = String(value); // Convert any value to string
                }

                // Only add the property if it's not empty or "false"
                if (value && value.toString().toLowerCase() !== 'false') {
                    properties[propName] = value;
                }
            }
        });

        // Blue Light is checked
        if (blueLightLensSwatch && blueLightLensSwatch.classList.contains('active-variant')) {
            let randomID = this.getAttribute('data-line-property-id');
            // Reaffirm that randomID is a string
            randomID = String(randomID);

            //console.log('Blue Light selected');
            if (this.getAttribute('data-line-property-frame') != 'FINAL SALE') {
                variantPropertiesLens = {
                    id: randomID,
                    Frame: 'EXCHANGE ONLY',
                };
            } else {
                variantPropertiesLens = {
                    id: randomID,
                    Frame: this.getAttribute('data-line-property-frame'),
                };
            }

            if (!show_sale_elements) {
                variantPropertiesLens = {
                    id: randomID,
                    Frame: 'EXCHANGE ONLY',
                    Note: 'Process time is additional 3 business days',
                };
            }
            if (this.getAttribute('data-include-frame-case') === 'true') {
                if (window.theme.preShopActive) {
                frameCaseProperties = {  
                    _Frame: 'FINAL SALE',
                    id: randomID
                };
                } else if (window.theme.isSaleActive) {
                    frameCaseProperties = {  
                        Frame: 'FINAL SALE',
                        id: randomID
                    };
                }
                formData = {
                    items: [
                        {
                            id: frameCaseID,
                            quantity: 1,
                            properties: frameCaseProperties,
                        },
                        {
                            id: 31707847557207,
                            quantity: 1,
                            properties: variantPropertiesLens,
                        },
                        {
                            id: variantId,
                            quantity: 1,
                            properties: properties,
                        },
                    ],
                };
            } else if (this.classList.contains('include-gwp')) {
                formData = {
                    items: [
                        {
                            id: window.theme.gwp_product,
                            quantity: 1,
                            properties: gwpProperties,
                        },
                        {
                            id: 31707847557207,
                            quantity: 1,
                            properties: variantPropertiesLens,
                        },
                        {
                            id: variantId,
                            quantity: 1,
                            properties: properties,
                        },
                    ],
                };
            } else {
                formData = {
                    items: [
                        {
                            id: 31707847557207,
                            quantity: 1,
                            properties: variantPropertiesLens,
                        },
                        {
                            id: variantId,
                            quantity: 1,
                            properties: properties,
                        },
                    ],
                };
            }

            //console.log('formData:', formData);

            // Blue Light Readers is checked
        } else if (
            blueLightReadersSwatch &&
            blueLightReadersSwatch.classList.contains('active-variant') &&
            blueLightReadersSwatch.classList.contains('has-readers-selected')
        ) {
            let randomID = this.getAttribute('data-line-property-id');
            // Reaffirm that randomID is a string
            randomID = String(randomID);
            let readersSelectedVariantID = parseInt(
                this.getAttribute('data-readers-selected-variant-id'),
                10,
            );

            //console.log('Readers selected');

            if (this.getAttribute('data-line-property-frame') != 'FINAL SALE') {
                variantPropertiesLens = {
                    id: randomID,
                    Frame: 'EXCHANGE ONLY',
                };
            } else {
                variantPropertiesLens = {
                    id: randomID,
                    Frame: this.getAttribute('data-line-property-frame'),
                };
            }

            if (!show_sale_elements) {
                variantPropertiesLens = {
                    id: randomID,
                    Frame: 'EXCHANGE ONLY',
                    Note: 'Process time is additional 3 business days',
                };
            }

            if (this.getAttribute('data-include-frame-case') === 'true') {
                if (window.theme.preShopActive) {
                    frameCaseProperties = {  
                        _Frame: 'FINAL SALE',
                        id: randomID
                    };
                } else if (window.theme.isSaleActive) {
                    frameCaseProperties = {  
                        Frame: 'FINAL SALE',
                        id: randomID
                    };
                }
                formData = {
                    items: [
                        {
                            id: frameCaseID,
                            quantity: 1,
                            properties: frameCaseProperties,
                        },
                        {
                            id: readersSelectedVariantID,
                            quantity: 1,
                            properties: variantPropertiesLens,
                        },
                        {
                            id: variantId,
                            quantity: 1,
                            properties: properties,
                        },
                    ],
                };
            } else if (this.classList.contains('include-gwp')) {
                    formData = {
                        items: [
                            {
                                id: window.theme.gwp_product,
                                quantity: 1,
                                properties: gwpProperties,
                            },
                            {
                                id: readersSelectedVariantID,
                                quantity: 1,
                                properties: variantPropertiesLens,
                            },
                            {
                                id: variantId,
                                quantity: 1,
                                properties: properties,
                            },
                        ]
                    }
            } else {
                formData = {
                    items: [
                        {
                            id: readersSelectedVariantID,
                            quantity: 1,
                            properties: variantPropertiesLens,
                        },
                        {
                            id: variantId,
                            quantity: 1,
                            properties: properties,
                        },
                    ],
                };
            }
            // Normal product
        } else {
            //console.log('no readers or blue light selected');
            if (this.getAttribute('data-include-frame-case') === 'true') {
                if (
                    this.getAttribute('data-hidden-add-on') !== null &&
                    this.getAttribute('data-hidden-add-on') !== ''
                ) {
                    formData = {
                        items: [
                            {
                                id: frameCaseID,
                                quantity: 1,
                                properties: frameCaseProperties,
                            },
                            {
                                id: parseInt(this.getAttribute('data-hidden-add-on'), 10),
                                quantity: 1,
                                properties: frameCaseProperties,
                            },
                            {
                                id: variantId,
                                quantity: 1,
                                properties: properties,
                            },
                        ],
                    };

                    mainItem = 2;
                } else {
                    
                    let randomUniqueID = Math.floor(Math.random() * 9999999 + 1);

                    if (window.theme.preShopActive) {
                        frameCaseProperties = {  
                            _Frame: 'FINAL SALE',
                            id: randomUniqueID
                        };
                    } else if (window.theme.isSaleActive) {
                        frameCaseProperties = {  
                            Frame: 'FINAL SALE',
                            id: randomUniqueID
                        };
                    }
                    if (randomUniqueID) {
                        properties.id = randomUniqueID;
                    }
                    formData = {
                        items: [
                            {
                                id: frameCaseID,
                                quantity: 1,
                                properties: frameCaseProperties,
                            },
                            {
                                id: variantId,
                                quantity: 1,
                                properties: properties,
                            },
                        ],
                    };

                    mainItem = 1;
                }
            } else {
                if (
                    this.getAttribute('data-hidden-add-on') !== null &&
                    this.getAttribute('data-hidden-add-on') !== ''
                ) {
                    formData = {
                        items: [
                            {
                                id: window.theme.gwp_product,
                                quantity: 1,
                                properties: gwpProperties,
                            },
                            {
                                id: parseInt(this.getAttribute('data-hidden-add-on'), 10),
                                quantity: 1,
                                properties: properties,
                            },
                            {
                                id: variantId,
                                quantity: 1,
                                properties: properties,
                            },
                        ],
                    };
                } else if (this.classList.contains('include-gwp')) {
                    formData = {
                        items: [
                            {
                                id: window.theme.gwp_product,
                                quantity: 1,
                                properties: gwpProperties,
                            },
                            {
                                id: variantId,
                                quantity: 1,
                                properties: properties,
                            }
                        ]
                    }
                
                } else {
                    formData = {
                        items: [
                            {
                                id: variantId,
                                quantity: 1,
                                properties: properties,
                            },
                        ],
                    };
                }
            }
        }

        //console.log('formData final:', formData);

        // Step 1: Clear the cart
        clearCart()
            .then(() => {
                // Step 2: Once the cart is cleared, add the item to the cart
                return addToCartBuyItNow(formData);
            })
            .then(() => {
                // Step 3: After adding the item to the cart, redirect to checkout
                if (window.routes.root_url === '/') {
                    window.location.href = 'https://www.krewe.com/checkout';
                } else {
                    window.location.href = window.routes.root_url + '/checkout';
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    });
}

function clearCart() {
    return fetch('/cart/clear.js', {
        method: 'POST',
    }).then((response) => {
        if (!response.ok) {
            throw new Error('Network response was not ok.');
        }
        return response.json();
    });
}

function addToCartBuyItNow(formData) {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
    }).then((response) => {
        if (!response.ok) {
            throw new Error('Network response was not ok.');
        }
        return response.json();
    });
}



if ($('.mini-cart--upsell--button').length) {
    $(document).on('click', '.mini-cart--upsell--button', function () {
        const variantId = this.getAttribute('data-variant-id');
        let formData;
        let properties = {};

        Object.keys(this.dataset).forEach((key) => {
            if (key.startsWith('lineProperty')) {
                let propName = key.replace('lineProperty', '').replace('Hidden', '');

                // Adjust the property name case based on whether it's hidden or not
                if (!key.includes('Hidden') && propName.toLowerCase() !== 'id') {
                    propName =
                        propName.charAt(0).toUpperCase() + propName.slice(1).toLowerCase();
                } else if (propName.toLowerCase() === 'id') {
                    propName = 'id';
                } else {
                    propName = '_' + propName.toLowerCase();
                }

                let value = this.dataset[key];

                // If the property name is 'id', ensure it's treated as a string
                if (propName === 'id') {
                    value = String(value); // Convert any value to string
                }

                // Only add the property if it's not empty or "false"
                if (value && value.toString().toLowerCase() !== 'false') {
                    properties[propName] = value;
                }
            }
        });

        formData = {
            items: [
                {
                    id: variantId,
                    quantity: 1,
                    properties: properties,
                },
            ],
        };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then((response) => response.json())
            .then((data) => {
                renderMiniCart(initialCartLoad, in_your_cart, backButtonCartLoad);

                var latestItem = data.items[0];
                // Extract required data from the latest item
                var itemData = {
                    title: latestItem.product_title,
                    price: (latestItem.price / 100).toFixed(2),
                    url: latestItem.url,
                    onSale: latestItem.total_discount > 0 ? true : false,
                };
                if (typeof mixpanel !== 'undefined') {
                    // Log extracted data in
                    mixpanel.track('Added to Cart', {
                        data: itemData,
                        Currency: data.currency,
                        Source: "Cart Mystery Deal",
                        Lens: "No Lens"
                    });
                }
                if (this.classList.contains('cart-upsell-buttons')) {
                    this.classList.add('mini-cart--upsell--button--in-cart');
                    this.innerHTML = 'In Cart';
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    });
}

/// Code for logging response
//.then(text => {
//  console.log("Raw response:", text); // Log the raw text
//  return JSON.parse(text); // Then parse it as JSON
//})

function unescapeHTML(str) {
    var txt = document.createElement('textarea');
    txt.innerHTML = str;
    return txt.value;
}

const miniCartBubble = document.querySelector('.cart-count-bubble');

function renderMiniCart(initialCartLoad, in_your_cart, backButtonCartLoad, removeButtonClicked) {
    //console.log('in your cart:', in_your_cart);

    // Fetch the cart JSON
    fetch(window.theme.marketPrefix + '/cart?view=cart-items')
        .then((response) => response.json())
        .then((data) => {
            const miniCart = document.querySelector('.mini-cart');
            const miniCartFooter = document.querySelector('.mini-cart-footer'); // The parent .mini-cart container
            
            if (miniCart) {
                // Only proceed if miniCartHeader exists
                const miniCartHeader = miniCart.querySelector('#cartHeader');
                const cartTitle = miniCartHeader.querySelector('.mini-cart-title');
                if (miniCartHeader) {
                    const shippingPriceSpan =
                        miniCartHeader.querySelector('.free-shipping-price');
                    const progressBar = miniCartHeader.querySelector('.shipping-progress-bar');


                    // Update the free shipping message
                    if (shippingPriceSpan) {
                        if (data.cart_threshold) {
                            
                            if (gwp_active) {
                                shippingPriceSpan.innerHTML = 'Congrats! You get a free gift';
                                $(".mini-cart-static-title").text("YOUR FREE GIFT? IT'S IN THE BAG");
                                $('#AddToCart:not(.pdp-low-inventory)').find('.product-shop-inventory-notice').addClass('gwp-message').html('<span class="longer-message">Includes gift with purchase</span><span class="shorter-message">+GIFT WITH PURCHASE</span>');
                                setTimeout(function () {
                                $('.mini-cart').addClass('confetti-active');
                                    window.cartConfetti(
                                        document.getElementById('confetti-canvas2'),
                                        {
                                            angle: 90,
                                            spread: 180,
                                            startVelocity: 40,
                                            elementCount: 50,
                                            decay: 0.7,
                                        },
                                    );
                                }, 400);
                            } else {
                                shippingPriceSpan.innerHTML = 'Congrats! You get free shipping';
                            }
                            if (
                                !removeButtonClicked &&
                                !initialCartLoad &&
                                !backButtonCartLoad
                            ) {
                                setTimeout(function () {
                                    if (window.theme.isSaleActive) {
                                        window.cartConfetti(
                                            document.getElementById('confetti-canvas2'),
                                            {
                                                angle: 90,
                                                spread: 180,
                                                startVelocity: 40,
                                                elementCount: 50,
                                                decay: 0.7,
                                            },
                                        );
                                    }
                                }, 400);
                            }
                        } else {
                            if (gwp_active) {
                        
                                if (gwp_type === 'frame') {
                                    //console.log('cart_threshold_percent:', data.cart_threshold_percent);
                                    $('#AddToCart:not(.pdp-low-inventory)').removeClass('gwp-message');
                                    if (data.cart_threshold_percent >= 100 && $('.low-inventory-message').length == 0) {
                                        //console.log('100');
                                        shippingPriceSpan.innerHTML = '';
                                        $(".mini-cart-static-title").text("YOUR FREE GIFT? IT'S IN THE BAG");
                                        $('.product-shop-inventory-notice').addClass('gwp-message').html('<span class="longer-message">Includes gift with purchase</span><span class="shorter-message">+GIFT WITH PURCHASE</span>');
                                       
                                    } else if (data.cart_threshold_percent >= 50 && $('.low-inventory-message').length == 0) {
                                        shippingPriceSpan.innerHTML = 'Add 1 frame to claim your free gift';
                                        $(".mini-cart-static-title").text("SUMMER GIFT WITH PURCHASE");
                                        $('.product-shop-inventory-notice').addClass('gwp-message').html('1 frame away from <span class="longer-message">a free</span> <span class="hide-on-mobile">summer</span> gift');
                                        //console.log('1 more to add');
                                    } else if ($('.low-inventory-message').length == 0) {
                                        shippingPriceSpan.innerHTML = 'Add 2 frames to claim your free gift';
                                        $(".mini-cart-static-title").text("SUMMER GIFT WITH PURCHASE");
                                        $('.product-shop-inventory-notice').addClass('gwp-message').html('2 frames away from <span class="longer-message">a free</span> <span class="hide-on-mobile">summer</span> gift');
                                        //console.log('2 more to add');
                                    }

                                } else {
                                    shippingPriceSpan.innerHTML = `You're <span class="left-to-go">${data.cart_threshold_dollars_left_to_go}</span> away from a free gift`;
                                }
                            } else {
                               
                                shippingPriceSpan.innerHTML = `You're <span class="left-to-go">${data.cart_threshold_dollars_left_to_go}</span> away from free shipping`;
                            }
                        }
                    } 
                    // Update the progress bar
                    if (progressBar) {
                        const progressBarActive =
                            progressBar.querySelector('.progress-bar-active');
                        if (progressBarActive) {
                            progressBar.setAttribute(
                                'data-free-shipping-progress',
                                data.cart_threshold_percent,
                            );
                            progressBarActive.style.width = `${data.cart_threshold_percent}%`;
                        }
                    }

                    
                }

                // Handle the mini-cart body
                let miniCartBody = miniCart.querySelector('.mini-cart-body');
                if (!miniCartBody) {
                    miniCartBody = document.createElement('div');
                    miniCartBody.className = 'mini-cart-body';
                    miniCart.insertBefore(
                        miniCartBody,
                        miniCart.querySelector('.mini-cart-footer'),
                    ); // Ensure miniCartBody is inserted before the footer
                } else {
                    miniCartBody.innerHTML = ''; // Clear the current cart contents
                }

                //console.log("show_sale_elements: " + show_sale_elements);

                if (data.empty) {
                    miniCartBody.remove();
                    
                    cartItemsCount = 0;
                    if (!window.theme.isSaleActive && !$('body').hasClass('pre-shop-area') && !window.theme.gwp_active) {
                        cartTitle.innerHTML = unescapeHTML(data.empty_header_text);
                        cartTitle.classList.remove('mini-cart-title-with-timer');
                    }

                    

                    if (useCartTimer && !$('body').hasClass('pre-shop-area')) {
                        resetTimerIfCartEmpty();
                    }

                    //console.log('Empty cart');
                    cartTimerStarted = false;
                    
                } else {
                    // Populate the cart items

                    cartItemsCount = data.item_count;

                    data.items.forEach((item, index) => {
                        // Create the container for the cart item
                        const itemElement = document.createElement('div');
                        itemElement.className = 'mini-cart-item';
                        itemElement.setAttribute('data-item-title', item.title);
                        itemElement.setAttribute(
                            'data-personalized-product',
                            item.properties.id || '',
                        );
                        itemElement.setAttribute(
                            'data-gwp-product',
                            item.properties.PROMO || '',
                        );
                        itemElement.setAttribute(
                            'data-family-name',
                            item.product_title_split,
                        );
                        itemElement.setAttribute('data-line', index + 1);
                        itemElement.setAttribute('data-item-key', item.key);
                        itemElement.setAttribute('data-add-on', item.add_on);
                        itemElement.setAttribute('data-has-hidden-add-on', item.hidden_add_on);
                        itemElement.setAttribute('data-variant-id', item.variant_id);
                        itemElement.setAttribute('data-frame-property', item.frame_property);
                        itemElement.setAttribute('data-is-preshop-item', item.is_preshop_item || false);

                        // Construct the item HTML
                        itemElement.innerHTML = `
                        <div class="mini-cart-item-image">
                            <a href="${item.url}">
                                <img src="${item.image_src}" alt="${
                            item.image_alt
                        }" class="block-fullwidth">
                                <div class="product-image-color-overlay"></div>
                                ${item.is_preshop_item ? '<div class="pre-shop-label">Pre-Shop</div>' : ''}
                            </a>
                        </div>
                        <div class="mini-cart-item-details" data-is-sale-item="${
                            item.sale_item
                        }">
                            <a href="${item.url}" style="display:block;position:relative;">
                                <div class="mini-cart-item-family-name">${
                                    item.product_title_split
                                }</div>
                                <div class="mini-cart-item-title">${item.title}</div>
                                ${
                                    item.variant_title && item.variant_title.includes('STRENGTH')
                                        ? `<div class="mini-cart-item-title">${item.variant_title}</div>`
                                        : ''
                                }


                            </a>
                            <div class='quantityPrice-wrapper'>
                                <div class="mini-cart-item-quantity">
                                    <span class="mini-cart-item-quantity-label">qty</span>
                                    <input type="text" pattern="[0-9]*" class="mini-cart-item-quantity-input js-line-item-quantity-input" value="${
                                        item.quantity
                                    }" data-line-number="${item.key}">
                                </div>
                                <div class="price--wrapper">
                                    ${
                                        item.line_compare_at_price &&
                                        item.line_compare_at_price !== '$0'
                                            ? `<div class="mini-cart-item-price mini-cart-item-compare-price">${item.line_compare_at_price}</div>`
                                            : ''
                                    }
                                    <div class="mini-cart-item-price">${item.line_price}</div>
                                    
                                </div>
                            </div>
                            ${show_sale_elements || has_unique_labels ? renderItemLabels(item.item_labels) : ''}
                            ${
                                show_sale_elements && item.sale_item
                                    ? renderItemProperties(
                                          item.sale_line_properties,
                                          item.extra20,
                                      )
                                    : ''
                            }
                            
                            ${
                                (!item.sale_item && !show_sale_elements) ||
                                (!item.sale_item && show_sale_elements) ||
                                (item.sale_item && !show_sale_elements)
                                    ? renderValueProps(item.value_props)
                                    : ''
                            }
                            ${
                                !show_sale_elements
                                    ? renderItemProperties(
                                          item.additional_properties,
                                          item.extra20,
                                      )
                                    : ''
                            }
                            <button class="mini-cart-item-remove" aria-label="Removes ${item.full_title} from cart" data-cart-remove="${index + 1}" data-item-on-sale="${item.is_on_sale}" data-item-full-title="${item.full_title}" data-attached-add-on="${item.hidden_add_on}" data-variant-id="${item.variant_id}">remove</button>
                        </div>
                        <div class="mini-cart-item-bottom-properties">
                                ${
                                    item.additional_properties
                                        ? renderItemProperties(
                                              item.additional_properties,
                                              item.extra20,
                                          )
                                        : ''
                                }
                        </div>
                    `;

                        // Append the item element to the mini cart body
                        miniCartBody.appendChild(itemElement);
                    });

                    if ($('.optical-random-id').length) {
                        $('#AddToCart').attr(
                            'data-line-property-id',
                            Math.floor(Math.random() * 9999999 + 1),
                        );
                    }

                    //console.log('Cart data loaded');

                    if (useCartTimer && !$('body').hasClass('pre-shop-area')) {
                        //console.log('Using cart timer');
                        if (!cartTimerStarted) {
                            cartTitle.innerHTML = unescapeHTML(data.cart_timer_text);
                            cartTitle.classList.add('mini-cart-title-with-timer');
                        }
                        
                        if (initialCartLoad) {
                            if (!cartTimerStarted) {
                                loadTimerState(timer60, "timer60", 3600, cartItemsCount);
                            }
                            
                        } else {
                            if (!cartTimerStarted) {
                                startTimer(timer60, 3600);
                            }
                        }

                        cartTimerStarted = true;
                    }
                    
                }

                // Handle the mini-cart footer and subtotal updates
                updateMiniCartFooter(data);

                // Update the cart bubble count
                const miniCartBubble = document.querySelector('.cart-count-bubble');
                if (miniCartBubble) {
                    miniCartBubble.innerHTML = data.empty
                        ? ''
                        : `<span>${data.item_count}</span>`;
                }
            }
            if (!initialCartLoad && !backButtonCartLoad && !buyNowButtonClick) {
                //console.log('not initial cart load');
                // Ensure the mini-cart is visible
                if (!in_your_cart) {
                    $('body').addClass('mini-cart-open');

                    if (document.body.classList.contains('keyboard-focus')) {
                        setTimeout(() => {
                            prioritizeCartTabIndex();
                        },200)
                    }
                }
            } else {
                //console.log('initial cart load');
            }
        })
        .catch((error) => {
            console.error('Error:', error);
        });
}

function updateMiniCartFooter(data) {
    const miniCart = document.querySelector('.mini-cart');
    let miniCartFooter = miniCart.querySelector('.mini-cart-footer');

    const subtotalPriceElement = miniCartFooter.querySelector('.mini-cart-bottom-total-price');
    const checkoutButtonElement = miniCartFooter.querySelector('.mini-cart-checkout');

    // Update the subtotal in the footer
    if (subtotalPriceElement) {
        subtotalPriceElement.textContent = data.subtotal;
    }

    // Toggle footer visibility based on cart emptiness
    if (data.empty) {
        miniCartFooter.classList.add('empty-cart');
        prependEmptyCartNotice(miniCart, miniCartFooter);
    } else {
        miniCartFooter.classList.remove('empty-cart');
        const existingNotice = miniCart.querySelector('.mini-cart-empty-notice');
        if (existingNotice) {
            existingNotice.remove();
        }
    }

    if (checkoutButtonElement && typeof data.footer.checkout_button_text !== 'undefined') {
        checkoutButtonElement.innerHTML = data.footer.checkout_button_text;
    }


}

function prependEmptyCartNotice(miniCart, miniCartFooter) {
    // Remove any existing empty cart notice to avoid duplicates
    const existingNotice = miniCart.querySelector('.mini-cart-empty-notice');
    if (existingNotice) {
        existingNotice.remove();
    }

    // Create and prepend the empty cart notice
    const emptyNotice = document.createElement('div');
    emptyNotice.className = 'mini-cart-empty-notice empty-notice';
    emptyNotice.innerHTML = `
    <div class="display-table">
      <div class="display-table-cell">
        <div>YOUR BAG LOOKS PRETTY EMPTY. <br> LET'S FIX THAT.<br>
          <span class="empty-message-link">
            <a href="/collections/new-arrivals-sun">SHOP NEW ARRIVALS</a>  
            <a href="/collections/best-sellers-sun">SHOP BEST SELLERS</a>
          </span>
        </div>
      </div>
    </div>
  `;
    miniCart.insertBefore(emptyNotice, miniCartFooter);
}

// Make sure to call updateMiniCartFooter from within your updateMiniCart function
// after processing the cart items to ensure the footer is updated correctly

const cartSVGIcons = {
    'icon-rare-find': `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="19" viewBox="0 0 24 19" fill="none"><path d="M4.87792 0.00305177H19.1319C19.2897 0.00302982 19.4453 0.0403472 19.5859 0.111954C19.7265 0.18356 19.8481 0.287422 19.9409 0.415052L23.7629 5.67105C23.8309 5.76457 23.8643 5.87876 23.8576 5.99417C23.8508 6.10958 23.8043 6.21909 23.7259 6.30405L12.3719 18.6041C12.3251 18.6548 12.2683 18.6953 12.205 18.723C12.1418 18.7507 12.0735 18.765 12.0044 18.765C11.9354 18.765 11.8671 18.7507 11.8038 18.723C11.7406 18.6953 11.6837 18.6548 11.6369 18.6041L0.282916 6.30505C0.20452 6.22009 0.157989 6.11058 0.151243 5.99517C0.144497 5.87976 0.177953 5.76557 0.245916 5.67205L4.06892 0.416052C4.1617 0.288422 4.28336 0.18456 4.42397 0.112953C4.56457 0.0413471 4.72013 0.00302982 4.87792 0.00305177Z" fill="white"/></svg>`,
    'icon-hot-item': `<svg xmlns="http://www.w3.org/2000/svg" width="37" height="35" viewBox="0 0 37 35" fill="none"><path d="M7.31664 34.3565L10.2181 21.8133L0.487061 13.3767L13.3427 12.2608L18.3422 0.431763L23.3416 12.2608L36.1973 13.3767L26.4663 21.8133L29.3677 34.3565L18.3422 27.7055L7.31664 34.3565Z" fill="white"/></svg>`,
    'icon-popular': `<svg xmlns="http://www.w3.org/2000/svg" width="120" height="70" viewBox="0 0 120 70" fill="none"><path d="M0.588623 60.7893L41.0117 20.3663L66.2209 45.5756L98.2745 13.522H72.5232V0.917358H119.791V48.1847H107.186V22.4335L66.2209 63.3985L41.0117 38.1892L9.5001 69.7008L0.588623 60.7893Z" fill="black"/></svg>`,
    'icon-unique': window.theme.unique_svg_cart_label
    // Add other icons as needed
};

function renderIcon(iconName) {
    return cartSVGIcons[iconName] || '';
}

// Helper function to render item labels
function renderItemLabels(labels) {
    let labelsHTML =
        '<div class="mini-cart-item-properties product-labels"><ul class="mini-cart-item-properties">';
    labels.forEach((label) => {
        // Assuming the label.type matches keys in cartSVGIcons, like "icon-rare-find", "icon-hot-item", etc.
        const iconHTML = renderIcon(`icon-${label.type.replace(/\s+/g, '-')}`); // Convert label type to icon key and fetch SVG HTML
        // Convert label type to icon key and fetch SVG HTML

        labelsHTML += `
        <li>
          <span class="cart-label">
            <div class="mini-cart-item-going-fast mini-cart-item-${label.type} cart-label-${label.id}">
              <span class="gtso-title">${label.title}</span>
              <span class="gtso-icon">${iconHTML}</span>
              <span class="gtso-text">${label.text}</span>
            </div>
          </span>
        </li>
      `;
    });
    labelsHTML += '</ul></div>';
    return labelsHTML;
}

// Helper function to render item properties
function renderItemProperties(properties, extra20 = false) {
    let propertiesHTML =
        '<div class="mini-cart-item-properties-wrapper"><ul class="mini-cart-item-properties">';

    properties.forEach((prop) => {
        propertiesHTML += `<li data-line-property-name="${prop.name}" data-line-property-value="${prop.value}">${prop.value}</li>`;
    });

    // Check if the extra20 flag is true and append the "Extra 20% off" line property
    if (extra20) {
        propertiesHTML += `<li data-line-property-name="ExtraDiscount">Extra 20% off Applied</li>`;
    }

    propertiesHTML += '</ul></div>';
    return propertiesHTML;
}

// Helper function to render value props
function renderValueProps(props) {
    if (props.length === 0) {
        return '';
    }

    let propertiesHTML =
        '<div class="mini-cart-item-properties-wrapper cart-value-prop-properties"><ul class="mini-cart-item-properties"><span class="vp-heading">Includes</span>';
    props.forEach((prop) => {
        propertiesHTML += `<li><span class="vp-text">${prop.value}</span></li>`;
    });
    propertiesHTML += '</ul></div>';
    return propertiesHTML;
}

function debounce(func, wait) {
    let timeout;
    return function () {
        const context = this,
            args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            func.apply(context, args);
        }, wait);
    };
}

document.addEventListener('input', function (e) {
    if (e.target && e.target.classList.contains('js-line-item-quantity-input')) {
        handleQuantityChange(e);
    }
});

const handleQuantityChange = debounce(function (e) {
    const line = parseInt(e.target.getAttribute('data-line-number'));
    const quantity = parseInt(e.target.value);
    updateQuantity(line, quantity);
}, 1000); // Debounce for 1 second

function updateQuantity(line, quantity) {
    fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            id: '' + line + '',
            quantity: quantity,
        }),
    })
        .then((response) => response.json())
        .then((data) => {
            renderMiniCart(initialCartLoad, in_your_cart, backButtonCartLoad);
        })
        .catch((error) => {
            console.error('Error:', error);
        });
}

document.addEventListener('click', function (e) {
    if (e.target && e.target.classList.contains('mini-cart-item-remove')) {
        // Get the main product's key and personalized-product id.
        const itemElement = e.target.closest('.mini-cart-item');
        const itemKey = itemElement.getAttribute('data-item-key');
        const personalizedProductId = itemElement.getAttribute('data-personalized-product');
        const isAddOn = itemElement.getAttribute('data-add-on') === 'true';
        const attachedAddOnId = itemElement.getAttribute('data-has-hidden-add-on');
        const frameProperty = itemElement.getAttribute('data-frame-property');
        const variantID = itemElement.getAttribute('data-variant-id');
        const itemTitle = e.target.getAttribute('data-item-full-title');
        const is_on_sale = e.target.getAttribute('data-item-on-sale');

        removeFromCart(
            itemKey,
            personalizedProductId,
            isAddOn,
            attachedAddOnId,
            frameProperty,
            variantID,
            itemTitle,
            is_on_sale
        );
    }
});

function removeFromCart(
    itemKey,
    personalizedProductId,
    isAddOn,
    attachedAddOnId,
    frameProperty,
    variantID,
    itemTitle,
    is_on_sale
) {
    let updates = { [itemKey]: 0 }; // Initialize updates object with the main item to be removed.
    let removeButtonClicked = true;

    // Check if the personalizedProductId is not empty and the item is not an add-on.
    if (!isAddOn && personalizedProductId) {
        document.querySelectorAll('.mini-cart-item').forEach((item) => {
            // Look for an add-on item with a matching personalized product ID.
            if (
                item.getAttribute('data-personalized-product') === personalizedProductId &&
                item.getAttribute('data-add-on') === 'true'
            ) {
                const addOnKey = item.getAttribute('data-item-key');
                updates[addOnKey] = 0; // Add the add-on item to the updates object.
            }
        });
    }

    // Check if there is an attached add-on based on `data-attached-add-on` and `data-frame-property`
    if (attachedAddOnId !== 'false') {
        document.querySelectorAll('.mini-cart-item').forEach((item) => {
            // Match the attached add-on by variant ID and frame property
            if (
                item.getAttribute('data-variant-id') === attachedAddOnId &&
                item.getAttribute('data-frame-property') === frameProperty
            ) {
                const attachedAddOnKey = item.getAttribute('data-item-key');
                updates[attachedAddOnKey] = 0; // Add the attached add-on item to the updates object.
            }
        });
    }

    //console.log('isaddon: ' + isAddOn);
    //console.log('itemKey: ' + itemKey);
    //console.log('attachedAddOnId: ' + attachedAddOnId);
    //console.log('frameProperty: ' + frameProperty);
    //console.log('variantID: ' + variantID);

    //console.log(updates);

    // Perform the cart update to remove items.
    fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates }),
    })
        .then((response) => response.json())
        .then((data) => {
            renderMiniCart(
                initialCartLoad,
                in_your_cart,
                backButtonCartLoad,
                removeButtonClicked,
            );

            
            updatePlpGridItemState(variantID);
            

            //console.log(variantID);
            if (typeof mixpanel !== 'undefined') {
                mixpanel.track('Item Removed', {
                    Name: itemTitle,
                    ID: variantID,
                    onSale: is_on_sale,
                    Source: window.theme.source
                });
            }

            //console.log('data', data);
        })
        .catch((error) => {
            console.error('Error:', error);
        });
}

function updatePlpGridItemState(variantID) {
    // Assuming the data-variant-id of the removed item is stored in either itemKey or attachedAddOnId,
    // and the main PLP grid items have data-product-variant-id attributes.

    //console.log(variantID);

    $('.plp-product-grid-item[data-product-variant-id="' + variantID + '"]').each(function () {
        var $this = $(this);

        $this.find('.button-to-update').removeClass('item-in-cart');
        $this.find('.card-wrapper').removeClass('in-cart');
        if ($(window).width() > 990) {
            if (
                $this.hasClass('extra-20-item') &&
                window.theme.currencyISO === 'USD' &&
                window.theme.extra20
            ) {
                $this.find('.button-to-update').html('Add to Bag for +20% Off');
            } else {
                $this.find('.button-to-update').html('Add to Bag');
            }
        } else {
            if (
                $this.hasClass('extra-20-item') &&
                window.theme.currencyISO === 'USD' &&
                window.theme.extra20
            ) {
                $this
                    .find('.button-to-update')
                    .html(
                        'Add to Bag for +20%',
                    );
            } else {
                $this
                    .find('.button-to-update')
                    .html(
                        'Add to Bag',
                    );
            }
        }
    });
}

$(document).on('click', '.shopify-payment-button__button', function () {
    var currentPageUrl = window.location.href;
    var totalPriceFormatted;
    var formData = new FormData();
    var distinctId = mixpanel.get_distinct_id();
    //console.log(distinctId);
    var headers = new Headers({ 'Content-Type': 'application/json' });

    var request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ attributes: { mixpanel_id: distinctId } }),
    };

    fetch('/cart/update.js', request);
    $.ajax({
        url: '/cart.js',
        dataType: 'json',
        success: function (cartData) {
            totalPriceFormatted = (cartData.total_price / 100).toFixed(2);
            if (typeof mixpanel !== 'undefined') {
                mixpanel.track('Checkout Started', {
                    method: 'Shop Pay',
                    URL: currentPageUrl,
                    Subtotal: totalPriceFormatted,
                });
            }
        },
        error: function (xhr, status, error) {
            console.error('Error fetching cart data:', error);
        },
    });
});

$('.mini-cart-checkout:not(.gwp-checkout)').click(function (event) {
    if (typeof mixpanel !== 'undefined') {
        event.preventDefault();
        
        //console.log(distinctId);

        if (typeof mixpanel.get_distinct_id === 'function') {

            var distinctId = mixpanel.get_distinct_id();

            fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ attributes: { mixpanel_id: distinctId } }),
            })
                .then((response) => response.json())
                .then((data) => {
                    var currentPageUrl = window.location.href;
                    var subtotal = $('.mini-cart-bottom-total-price').text();

                    // Log "Checkout clicked" along with the subtotal in the console
                    //console.log('Checkout clicked. Subtotal: ' + subtotal);

                    mixpanel.track('Checkout Started', {
                        method: 'Cart Checkout',
                        URL: currentPageUrl,
                        Subtotal: subtotal,
                    });

                    // Step 3: After adding the item to the cart, redirect to checkout
                    if (window.routes.root_url === '/') {
                        window.location.href = '/checkout';
                        //console.log('Tried to redirect to /checkout');
                    } else {
                        window.location.href = window.routes.root_url + '/checkout';
                    }

                    //console.log('Tried to redirect');


                    //console.log('data', data);
                })
                .catch((error) => {
                    console.error('Error:', error);

                    // Step 3: After adding the item to the cart, redirect to checkout
                    if (window.routes.root_url === '/') {
                        window.location.href = 'https://www.krewe.com/checkout';
                    } else {
                        window.location.href = window.routes.root_url + '/checkout';
                    }
                });
        } else {

            var currentPageUrl = window.location.href;
            var subtotal = $('.mini-cart-bottom-total-price').text();

            // Log "Checkout clicked" along with the subtotal in the console
            //console.log('Checkout clicked. Subtotal: ' + subtotal);

            mixpanel.track('Checkout Started', {
                method: 'Cart Checkout',
                URL: currentPageUrl,
                Subtotal: subtotal,
            });

            // Step 3: After adding the item to the cart, redirect to checkout
            if (window.routes.root_url === '/') {
                window.location.href = 'https://www.krewe.com/checkout';
            } else {
                window.location.href = window.routes.root_url + '/checkout';
            }

        }

    } else {
        // Step 3: After adding the item to the cart, redirect to checkout
        if (window.routes.root_url === '/') {
            window.location.href = 'https://www.krewe.com/checkout';
        } else {
            window.location.href = window.routes.root_url + '/checkout';
        }
    }

    // Your additional tracking code can go here
});


function addGWPProduct() {
        if ($('.mini-cart-item[data-gwp-product="GWP QUALIFIER').length) {
            const variantId = window.theme.gwp_product;
            let formData;
            let properties = {
                PROMO: 'Free with Purchase',
            };

            formData = {
                items: [
                    {
                        id: variantId,
                        quantity: 1,
                        properties: properties,
                    },
                ],
            };

            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            })
                .then((response) => response.json())
                .then((data) => {
                    // Step 3: After adding the item to the cart, redirect to checkout
                if (window.routes.root_url === '/') {
                    window.location.href = 'https://www.krewe.com/checkout';
                } else {
                    window.location.href = window.routes.root_url + '/checkout';
                }
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
            } else {
                if (window.routes.root_url === '/') {
                    window.location.href = 'https://www.krewe.com/checkout';
                } else {
                    window.location.href = window.routes.root_url + '/checkout';
                }
            }
}

function addGWPProductTracked() {
    if ($('.mini-cart-item[data-gwp-product="GWP QUALIFIER"]').length) {
        const variantId = window.theme.gwp_product;
        let formData = {
            items: [
                {
                    id: variantId,
                    quantity: 1,
                    properties: {
                        PROMO: 'Free with Purchase',
                    },
                },
            ],
        };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
        .then(response => response.json())
        .then(data => {
            if (typeof mixpanel !== 'undefined') {
                if (typeof mixpanel.get_distinct_id === 'function') {
                    var distinctId = mixpanel.get_distinct_id();
                    fetch(window.Shopify.routes.root + 'cart/update.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ attributes: { mixpanel_id: distinctId } }),
                    })
                    .then(response => response.json())
                    .then(data => {
                        trackMixpanelAndRedirect();
                    })
                    .catch((error) => {
                        console.error('Error updating cart with Mixpanel ID:', error);
                        trackMixpanelAndRedirect();
                    });
                } else {
                    trackMixpanelAndRedirect();
                }
            } else {
                redirectToCheckout();
            }
        })
        .catch(error => {
            console.error('Error adding GWP Product:', error);
            redirectToCheckout();
        });
    } else {
        redirectToCheckout();
    }
}

function trackMixpanelAndRedirect() {
    var currentPageUrl = window.location.href;
    var subtotal = $('.mini-cart-bottom-total-price').text();
    mixpanel.track('Checkout Started', {
        method: 'Cart Checkout',
        URL: currentPageUrl,
        Subtotal: subtotal,
    });
    redirectToCheckout();
}

function redirectToCheckout() {
    if (window.routes.root_url === '/') {
        window.location.href = 'https://www.krewe.com/checkout';
    } else {
        window.location.href = window.routes.root_url + '/checkout';
    }
}


$(document).on('click', '.mini-cart-checkout.gwp-checkout', function (e) {
    e.preventDefault();
    addGWPProductTracked();
});

// Function to place the cursor at the end of the input
function placeCursorAtEnd(el) {
    // Focus on the input and set cursor to the end of the text
    const length = el.value.length;
    el.setSelectionRange(length, length);
  }
  
  // Event delegation for dynamically added inputs
document.addEventListener('focusin', function(event) {
// Check if the focused element is a .mini-cart-item-quantity-input
if (event.target.matches('.mini-cart-item-quantity-input')) {
    // Delay to ensure focus completes before setting cursor
    setTimeout(() => placeCursorAtEnd(event.target), 0);
}
});

class DragScroll {
    constructor(selector) {
        this.carousel = document.querySelector(selector);
        // Only proceed if element exists
        if (!this.carousel) return;

        this.isDragging = false;
        this.startX = 0;
        this.scrollLeft = 0;
        this.velocity = 0;
        this.lastX = 0;
        this.rafId = null;
        
        this.init();
    }

    init() {
        // Prevent mobile touch events from interfering
        if (window.innerWidth >= 1024) {
            this.carousel.addEventListener('mousedown', this.startDragging.bind(this));
            this.carousel.addEventListener('mouseleave', this.stopDragging.bind(this));
            this.carousel.addEventListener('mouseup', this.stopDragging.bind(this));
            this.carousel.addEventListener('mousemove', this.drag.bind(this));
        }

        // Prevent image drag
        this.carousel.querySelectorAll('img').forEach(img => {
            img.setAttribute('draggable', 'false');
        });
    }

    startDragging(e) {
        this.isDragging = true;
        this.startX = e.pageX - this.carousel.offsetLeft;
        this.scrollLeft = this.carousel.scrollLeft;
        this.lastX = e.pageX;
        this.velocity = 0;
        
        if (this.rafId) {
            cancelAnimationFrame(this.rafId);
        }
        
        this.carousel.style.cursor = 'grabbing';
        this.carousel.style.userSelect = 'none';
    }

    stopDragging() {
        if (!this.isDragging) return;
        this.isDragging = false;
        this.carousel.style.cursor = 'grab';
        this.carousel.style.userSelect = 'auto';
        
        if (Math.abs(this.velocity) > 0.1) {
            this.applyMomentum();
        }
    }

    drag(e) {
        if (!this.isDragging) return;
        e.preventDefault();
        
        const x = e.pageX - this.carousel.offsetLeft;
        const walk = (x - this.startX) * 1.5;
        this.carousel.scrollLeft = this.scrollLeft - walk;
        
        this.velocity = (e.pageX - this.lastX) * 0.1;
        this.lastX = e.pageX;
    }

    applyMomentum() {
        const friction = 0.95;
        this.carousel.scrollLeft -= this.velocity;
        this.velocity *= friction;

        if (Math.abs(this.velocity) > 0.1) {
            this.rafId = requestAnimationFrame(this.applyMomentum.bind(this));
        }
    }
}

// Usage
document.addEventListener('DOMContentLoaded', () => {
    // Will only initialize if the element exists
    const carousel = new DragScroll('.mini-cart-upsell-carousel');
});

// Listen for pre-shop updates from mini-cart
document.addEventListener('mini-cart:pre-shop-updated', function() {
  // Check if we need to update our pre-shop state
  const isCurrentlyPreShop = isPreShopUser();
  if (isCurrentlyPreShop) {
    // Handle specific cart-drawer.js behavior for pre-shop mode
    resetTimer(timer60, "timer60", 3600);
    cartTimerStarted = false;
  } else {
    // Handle specific cart-drawer.js behavior for standard mode
    if (useCartTimer && !cartTimerStarted && cartItemsCount > 0) {
      if (initialCartLoad) {
        loadTimerState(timer60, "timer60", 3600, cartItemsCount);
      } else {
        startTimer(timer60, 3600);
      }
      cartTimerStarted = true;
    }
  }
});

// Function to handle getLocalLaunchTimeCart if it doesn't exist
if (typeof getLocalLaunchTimeCart !== 'function') {
  window.getLocalLaunchTimeCart = function() {
    const targetDate = new Date('2025-03-04T10:00:00-05:00'); // 10am EST
    
    // Get the time in user's local timezone
    const localTime = targetDate.toLocaleTimeString('en-US', {
      hour: 'numeric', // Only show hour
      hour12: true     // Use 12-hour format (AM/PM)
    });
    
    // Remove any spaces and convert to lowercase
    const shortTime = localTime.replace(/\s/g, '').toLowerCase();
    
    // Get timezone abbreviation
    const timezoneOffset = targetDate.getTimezoneOffset();
    let timezoneAbbr = '';
    
    // Convert timezone offset to hours (negative because getTimezoneOffset returns opposite sign)
    const offsetHours = -timezoneOffset / 60;
    
    // Determine timezone abbreviation based on offset
    if (offsetHours === -5) {
      timezoneAbbr = 'ET'; // Eastern Time
    } else if (offsetHours === -6) {
      timezoneAbbr = 'CT'; // Central Time
    } else if (offsetHours === -7) {
      timezoneAbbr = 'MT'; // Mountain Time
    } else if (offsetHours === -8) {
      timezoneAbbr = 'PT'; // Pacific Time
    } else {
      // For other timezones, use the browser's timezone abbreviation
      const options = { timeZoneName: 'short' };
      const timeZoneString = new Intl.DateTimeFormat('en-US', options).format(targetDate);
      timezoneAbbr = timeZoneString.split(' ').pop();
    }
    
    return shortTime + ' ' + timezoneAbbr;
  };
}

// Ensure theme settings are properly set up
if (typeof window.theme === 'undefined') {
  window.theme = {};
}

// Set up pre-shop active status if not defined
if (typeof window.theme.preShopActive === 'undefined') {
  // Default to false, should be set in theme settings
  window.theme.preShopActive = false;
}

// Initialize cart timer active status if not defined
if (typeof window.theme.cart_timer_active === 'undefined') {
  window.theme.cart_timer_active = useCartTimer || false;
}
